import styled, { css } from 'styled-components';
import ColorConstants from '../constants/ColorConstants';
import { ButtonColors, ButtonSize, ButtonVariant } from './default-button.type';

const getSizeStyles = (size:ButtonSize) => {
    const customSyles = {
        [ButtonSize.SMALL]: `
    width: 104px;
    height: 40px;
    `,
        [ButtonSize.LARGE]: '',
        [ButtonSize.FULL_LARGE]: `
    width: 100%;
  `,
    };

    return customSyles[size];
};

const getButtonColor = (like: ButtonColors) => {
    const customStyles = {
        [ButtonColors.ADDING]: `
    background-color: ${ColorConstants.ADDING};

    & ${BaseLabel} {
    color: ${ColorConstants.white};
    }
  `,
        [ButtonColors.DESCTRUCTIVE]: '',
        [ButtonColors.DEFAULT]: '',
    };

    return customStyles[like];
};

const getVariantStyles = (variant : ButtonVariant) => {
    const variantStyles = {
        [ButtonVariant.CONTAINED]: '',
        [ButtonVariant.OUTLINED]: `
        background-color: ${ColorConstants.white};
        & ${BaseLabel} {
          color: ${ColorConstants['regal-blue-50%']};
          }
        `,
    };

    return variantStyles[variant];
};


export const BaseButton = styled.button`
  border-radius: 26px;
  width: 185px;
  height: 52px;
  border: 1px solid ${ColorConstants['regal-blue-20%']};
  background-color: ${ColorConstants.GRAY_5};

  &:hover {
    opacity: 0.8; 
  }
  
  ${({ color }) => color && css`${getButtonColor(color)}`}
  ${({ size }) => size && css`${getSizeStyles(size)}`}
  ${({ variant }) => variant && css`${getVariantStyles(variant)}`}
`;

export const BaseLabel = styled.span`
  width: 41px;
  height: 24px;
  font-family: Helvetica;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorConstants['regal-blue-20%']};
`;

export const WrapperTwoButtons = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;

  & ${BaseButton}:first-child {
    margin-right: 10px;
  }
`;
